import { useState, useRef } from "react"
import PauseIcon from "../../assets/icons/pause-icon"
import PlayIcon from "../../assets/icons/play-icon"

interface AudioPlayerProps {
    audioSrc: string
    borderRadiusTop: boolean
    trackPauseEvent?: () => void
    trackPlayEvent?: () => void
}
const AudioPlayer = ({
    audioSrc,
    borderRadiusTop = false,
    trackPauseEvent = () => null,
    trackPlayEvent = () => null,
}: AudioPlayerProps) => {
    const [isPlaying, setIsPlaying] = useState(false)
    const [duration, setDuration] = useState(0)
    const [currentTime, setCurrentTime] = useState(0)

    const audioPlayer = useRef() as any // reference our audio component
    const progressBar = useRef() as any // reference our progress bar
    const animationRef = useRef() as any // reference the animation

    const calculateTime = (sec: number) => {
        const minutes = Math.floor(sec / 60)
        const returnedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`
        const seconds = Math.floor(sec % 60)
        const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`
        return `${returnedMinutes}:${returnedSeconds}`
    }

    const togglePlayPause = () => {
        const prevValue = isPlaying
        setIsPlaying(!prevValue)
        if (!prevValue) {
            trackPlayEvent()
            audioPlayer.current.play()
            animationRef.current = requestAnimationFrame(whilePlaying)
        } else {
            trackPauseEvent()
            audioPlayer.current.pause()
            cancelAnimationFrame(animationRef.current)
        }
    }

    const whilePlaying = () => {
        progressBar.current.value = audioPlayer.current.currentTime
        changePlayerCurrentTime()
        animationRef.current = requestAnimationFrame(whilePlaying)
    }

    const changeRange = () => {
        audioPlayer.current.currentTime = progressBar.current.value
        changePlayerCurrentTime()
    }

    const changePlayerCurrentTime = () => {
        progressBar.current.style.setProperty(
            "background-size",
            `${(progressBar.current.value / duration) * 100}% 100%`
        )
        setCurrentTime(progressBar.current.value)
    }
    const setDurationFunction = () => {
        const seconds = Math.floor(audioPlayer.current.duration)
        setDuration(seconds)
        progressBar.current.max = seconds
    }

    return (
        <div
            className={`flex w-[100%] items-center border-[#F4F2F6] border border-solid px-4 py-3 ${
                borderRadiusTop ? "rounded-t-lg" : "rounded-lg"
            } bg-white`}
        >
            <audio
                ref={audioPlayer}
                preload="auto"
                src={audioSrc}
                onCanPlayThrough={setDurationFunction}
            />

            <button onClick={togglePlayPause}>
                {isPlaying ? <PauseIcon /> : <PlayIcon />}
            </button>

            {/* progress bar */}
            <div className="w-[100%] ml-2 flex items-center">
                <input
                    type="range"
                    defaultValue="0"
                    ref={progressBar}
                    onChange={changeRange}
                />
            </div>
            {/* duration */}
            <div className="text-xs font-medium ml-2">
                {calculateTime(currentTime)}/
                {duration && !isNaN(duration) && calculateTime(duration)}
            </div>
        </div>
    )
}

export default AudioPlayer
